import { TypographyH2 } from '@talentmesh/ui/components/typography';
import { useCreateRecruitmentContext } from '../../../../Create/Contexts/CreateRecruitmentContext';
import CTMonitoringTooltipBody from './Components/CTMonitoringTooltipBody';
import { useJobFunctions } from '@/api/useJobFunctions';
import InfoTooltip from '@/Components/Tooltip/InfoTooltip';
import { getJobCategoryJobFunctionPair } from '@/Utils/JobFunctionSelectionUtils';
import UIStrings from '@/Utils/UIStrings';

function SelectTestsStepHeader() {
    const { data: jobFunctionsMap } = useJobFunctions();
    const {
        jobDetails: { jobFunctionId },
    } = useCreateRecruitmentContext();

    const { jobFunctionName } = getJobCategoryJobFunctionPair(jobFunctionsMap?.jobCategories ?? [], jobFunctionId);

    return (
        <div className="flex items-center justify-center">
            <div className="mx-auto flex w-full flex-col items-center justify-center gap-3 px-8 py-6">
                <div className="text-center">
                    <TypographyH2 className="text-foreground text-center tracking-tight">
                        {`${UIStrings.SkillsTestsForJobFunctionName(jobFunctionName ?? '')} `}
                    </TypographyH2>
                </div>
                <p className="text-foreground text-center align-middle text-base leading-relaxed">
                    {UIStrings.QuickSummaryRecommendationStep}
                    <InfoTooltip className="align-top" description={<CTMonitoringTooltipBody />} />
                </p>
            </div>
        </div>
    );
}

export default SelectTestsStepHeader;
